<template>
  <div>
    <el-row :gutter="20">
      <el-col :span="3">
        <el-card class="list-selector">
          <ul class="list-selector-list">
            <li @click="switchCoupon({ couponName: $t('common.all'), couponId: '' })"
              :class="{ 'selected': receiveLogInfo.conditions.couponId === '' }">
              {{ $t('common.all') }}
            </li>
            <li v-for="(item, index) in receiveLogInfo.coupons" :key="index"
              @click="switchCoupon(item)"
              :class="{ 'selected': receiveLogInfo.conditions.couponId == item.couponId }">
              {{ item.couponName }}
            </li>
          </ul>
        </el-card>
      </el-col>
      <el-col :span="21">
        <el-card>
          <div slot="header" class="clearfix flex justify-between">
            <span>{{ $t('platformCoupon.queryCondition') }}</span>
          </div>
          <el-form :inline="true" class="demo-form-inline text-left">
            <el-form-item>
              <el-input v-model="receiveLogInfo.conditions.couponNameLike"
                :placeholder="$t('platformCoupon.selectCouponName')" clearable style="width:200px" />
            </el-form-item>
            <el-form-item>
              <el-input v-model="receiveLogInfo.conditions.couponCodeLike"
                :placeholder="$t('platformCoupon.selectCouponCode')" clearable style="width:200px" />
            </el-form-item>
            <el-form-item>
              <el-input v-model="receiveLogInfo.conditions.userName"
                :placeholder="$t('platformCoupon.userName')" clearable style="width:200px" />
            </el-form-item>
            <el-form-item>
              <el-input v-model="receiveLogInfo.conditions.tel"
                :placeholder="$t('platformCoupon.phoneNumber')" clearable style="width:200px" />
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="_queryReceiveLogMethod()">
                <i class="el-icon-search"></i> {{ $t('platformCoupon.query') }}
              </el-button>
              <el-button @click="_resetReceiveLogMethod()">
                <i class="el-icon-refresh"></i> {{ $t('common.reset') }}
              </el-button>
            </el-form-item>
          </el-form>
        </el-card>

        <el-card style="margin-top: 20px;">
          <div slot="header" class="clearfix flex justify-between">
            <span>{{ $t('platformCoupon.receiveLogs') }}</span>
          </div>
          <el-table :data="receiveLogInfo.receiveLogs" border style="width:100%" v-loading="loading">
            <el-table-column prop="couponCode" :label="$t('platformCoupon.couponCode')" align="center" />
            <el-table-column prop="couponName" :label="$t('platformCoupon.couponName')" align="center" />
            <el-table-column prop="userName" :label="$t('platformCoupon.userName')" align="center" />
            <el-table-column prop="tel" :label="$t('platformCoupon.phoneNumber')" align="center" />
            <el-table-column prop="createTime" :label="$t('platformCoupon.receiveTime')" align="center" />
            <el-table-column prop="receiveType" :label="$t('platformCoupon.receiveType')" align="center">
              <template slot-scope="scope">
                {{ scope.row.receiveType === '01' ? $t('platformCoupon.userReceive') : $t('platformCoupon.shopGive') }}
              </template>
            </el-table-column>
          </el-table>
          <el-pagination @current-change="handleCurrentChange" :current-page.sync="receiveLogInfo.conditions.page"
            :page-size="receiveLogInfo.conditions.row" layout="total, prev, pager, next"
            :total="receiveLogInfo.total" style="margin-top: 20px; text-align: right;">
          </el-pagination>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { listPlatformCouponReceiveLog, listPlatformCoupon } from '@/api/coupon/couponApi'

export default {
  name: 'PlatformCouponReceiveLog',
  data() {
    return {
      loading: false,
      receiveLogInfo: {
        receiveLogs: [],
        coupons: [],
        total: 0,
        conditions: {
          couponNameLike: '',
          couponCodeLike: '',
          userName: '',
          tel: '',
          couponId: '',
          page: 1,
          row: 10
        }
      }
    }
  },
  created() {
    this._listCoupons()
    this._listReceiveLogs()
  },
  methods: {
    async _listCoupons() {
      try {
        // statusCd 传空串=全部（含已下架券），保证历史日志可按已下架券过滤
        const res = await listPlatformCoupon({
          statusCd: '',
          page: 1,
          row: 100
        })
        this.receiveLogInfo.coupons = res.data || []
      } catch (error) {
        console.error('获取平台优惠券列表失败:', error)
      }
    },
    async _listReceiveLogs() {
      this.loading = true
      try {
        // couponBelong 已在 api 层固定注入 PLATFORM，此处不再传 shopId/couponBelong
        const res = await listPlatformCouponReceiveLog(this.receiveLogInfo.conditions)
        // 分页契约：records=页数，total=总数，列表数据取 data，总数取 total
        this.receiveLogInfo.receiveLogs = res.data
        this.receiveLogInfo.total = res.total
      } catch (error) {
        console.error('获取平台券领取记录失败:', error)
      } finally {
        this.loading = false
      }
    },
    _queryReceiveLogMethod() {
      this.receiveLogInfo.conditions.page = 1
      this._listReceiveLogs()
    },
    _resetReceiveLogMethod() {
      this.receiveLogInfo.conditions.couponNameLike = ''
      this.receiveLogInfo.conditions.couponCodeLike = ''
      this.receiveLogInfo.conditions.userName = ''
      this.receiveLogInfo.conditions.tel = ''
      this.receiveLogInfo.conditions.page = 1
      this._listReceiveLogs()
    },
    handleCurrentChange(val) {
      this.receiveLogInfo.conditions.page = val
      this._listReceiveLogs()
    },
    switchCoupon(coupon) {
      this.receiveLogInfo.conditions.couponId = coupon.couponId || ''
      this.receiveLogInfo.conditions.page = 1
      this._listReceiveLogs()
    }
  }
}
</script>

<style scoped>
/* 使用 el-card 和全局 list-selector 样式，无需自定义样式 */
</style>
